import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import {
  alert,
  GET,
  POST,
  PUT,
  loading,
  required,
  Navbar,
  Modal,
} from "../../components/CustomComponent.js";
export default class PhoneticMaps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],
      loaded: false,
      count: 10,

      source_char: "",
      target_chunk: "",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get();
  }
  Get = async () => {
    const { filter_search } = this.state;
    loading(true);
    let [result] = await Promise.all([
      GET("v1/admin/phonetic-maps", { data_search: this.state.filter_search }),
    ]);
    this.setState({
      data: Object.entries(result.data).map(([key, value]) => ({ key: key, value: value})).filter(e=>!filter_search || filter_search === e.key  || e.value.includes(filter_search)),
      loaded: true,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const { source_char, target_chunk } = this.state;
    if (!target_chunk.trim()) {
      alert("", "warning", "Warning", "Please input Target Chunk");
      return;
    }
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        source_char,
        target_chunk,
      };

      let result = await POST("v1/admin/phonetic-maps", body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };
  // -------------------------------------------------------------------------
  // Render helpers (presentation only — Get / CreateUpdate unchanged)
  // -------------------------------------------------------------------------
  openAdd = (item) => {
    this.setState({ source_char: item.key, target_chunk: "", modal_create: true });
  };
  closeModal = () => {
    this.setState({ modal_create: false });
  };
  chunksOf = (value) =>
    (Array.isArray(value) ? value : String(value ?? "").split(","))
      .map((e) => String(e).trim())
      .filter(Boolean);
  render() {
    const { modal_create, filter_search, data, loaded, source_char, target_chunk } =
      this.state;
    const rows = Array.isArray(data) ? data : [];
    const totalChunks = rows.reduce((acc, e) => acc + this.chunksOf(e.value).length, 0);
    const currentChunks = this.chunksOf(
      rows.find((e) => e.key === source_char)?.value
    );
    const duplicate =
      !!target_chunk.trim() && currentChunks.includes(target_chunk.trim());
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Configuration</div>
                <div className="ar-title">Phonetic Maps</div>
                <div className="ar-subtitle">
                  Manage phonetic maps used to match names in mismatch cases.
                </div>
              </div>
              <div className="pu-hero-legend d-none d-md-flex align-items-center gap-3">
                <span>
                  <b className="pu-hero-num">{rows.length}</b> character{rows.length === 1 ? "" : "s"}
                </span>
                <span className="ar-divider" />
                <span>
                  <b className="pu-hero-num">{totalChunks}</b> chunk{totalChunks === 1 ? "" : "s"}
                </span>
              </div>
            </div>

            <div className="ar-toolbar ar-filter mt-3">
              <div className="ar-filter-head">
                <span className="ar-toolbar-label">
                  <span className="icon me-2">{""}</span>Filter
                </span>
              </div>
              <div className="ar-filter-row">
                <div className="ar-filter-field ar-filter-field-search">
                  <span className="ar-filter-label">Search</span>
              <input
                type="text"
                className="form-control"
                placeholder="Search character or chunk..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
                </div>
              <div className="ar-toolbar-actions">
              <button className="ar-btn-gold" onClick={() => this.Get(1)}>
                <span className="icon me-2">{""}</span>Search
              </button>
              <button
                className="ar-btn-ghost"
                onClick={() => {
                  this.setState({ filter_search: "" }, () => this.Get(1));
                }}
              >
                Reset
              </button>
              </div>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{""}</span>
                  Character Map
                </div>
                <div className="ar-table-caption">
                  {rows.length} character{rows.length === 1 ? "" : "s"} · {totalChunks} chunk
                  {totalChunks === 1 ? "" : "s"}
                  {filter_search.trim() ? ` · filtered by "${filter_search.trim()}"` : ""}
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover ar-table pu-table">
                <thead>
                  <tr>
                    <td className="text-nowrap wpx-140">Character</td>
                    <td className="text-nowrap">List</td>
                    <td className="text-center text-nowrap phonetic-maps.update td-actions">Actions</td>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((item, index) => {
                    const chunks = this.chunksOf(item.value);
                    return (
                      <tr key={item.key || `array-${index}`}>
                        <td data-label="Character" className="text-nowrap">
                          <div className="d-flex align-items-center gap-3">
                            <span className="pu-glyph">{item.key || "-"}</span>
                            <span className="pu-sub">
                              {chunks.length} chunk{chunks.length === 1 ? "" : "s"}
                            </span>
                          </div>
                        </td>
                        <td data-label="List">
                          {chunks.length ? (
                            <div className="pu-chunks">
                              {chunks.map((c, i) => (
                                <span className="pu-chunk" key={`${item.key}-${i}`}>
                                  {c}
                                </span>
                              ))}
                            </div>
                          ) : (
                            <span className="pu-none">No chunk yet</span>
                          )}
                        </td>
                        <td data-label="Actions" className="text-center phonetic-maps.update td-actions">
                          <Dropdown align="end">
                            <Dropdown.Toggle className="pu-action-toggle" id={`phonetic-actions-${index}`}>
                              Action
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                            <Dropdown.Item
                              className="pu-action-item phonetic-maps.update"
                              onClick={() => this.openAdd(item)}
                            >
                              <span className="icon">{"\uf067"}</span>Add chunk
                            </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                  {loaded && rows.length === 0 && (
                    <tr>
                      <td colSpan={3} className="p-0 border-0">
                        <div className="pr-empty rounded-0 border-0">
                          <span className="icon">{""}</span>
                          <div className="fw-bold">No phonetic map found</div>
                          <div className="text-secondary text-14">
                            Try another character or chunk.
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* CREATE UPDATE */}
        <Modal
          show={modal_create}
          dialogClassName="pr-modal pr-scope pu-scope"
          onHide={this.closeModal}
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div className="d-flex align-items-center gap-3">
              <span className="pu-glyph pu-glyph-hero">{source_char || "?"}</span>
              <div>
                <div className="pr-modal-eyebrow">Phonetic map</div>
                <h5 className="fw-bold mb-0">Add Target Chunk</h5>
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>Source Character
              </div>
              <div className="pu-source-char">{source_char}</div>
              <div className="pu-hint mt-2">
                {currentChunks.length
                  ? `${currentChunks.length} existing chunk${currentChunks.length === 1 ? "" : "s"}`
                  : "No chunk mapped to this character yet"}
              </div>
              {currentChunks.length > 0 && (
                <div className="pu-chunks mt-2">
                  {currentChunks.map((c, i) => (
                    <span className="pu-chunk" key={`cur-${i}`}>
                      {c}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div className="pu-section">
              <div className="pu-section-title">
                <span className="icon">{""}</span>New Chunk
              </div>
              <label className="pr-label">Target Chunk{required}</label>
              <input
                type="text"
                className={`form-control pr-input ${duplicate ? "is-invalid" : ""}`}
                placeholder="e.g. kh, k, c"
                autoFocus
                onChange={(e) => {
                  this.setState({ target_chunk: e.target.value });
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") this.CreateUpdate();
                }}
                value={target_chunk}
              />
              <div className={`pu-hint ${duplicate ? "text-danger" : ""}`}>
                {duplicate
                  ? "This chunk already exists for the character."
                  : "The chunk is appended to the character's list."}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer">
            <button
              className="btn btn-dark px-5 me-1 rounded-pill phonetic-maps.create"
              onClick={() => {
                this.CreateUpdate();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-outline-dark px-5 ms-1 rounded-pill"
              onClick={this.closeModal}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
